export const FETCH_TRANSACTIONS_PROFITS_START = "FETCH_TRANSACTIONS_PROFITS_START";
export const FETCH_TRANSACTIONS_PROFITS_SUCCESS = "FETCH_TRANSACTIONS_PROFITS_SUCCCESS";
export const FETCH_TRANSACTIONS_PROFITS_FAIL = "FETCH_TRANSACTIONS_PROFITS_START";